import {Routes, Route} from "react-router-dom"
import Layout from "../components/Layout"
import Signin from "./Signin"
import SigninBouyges from "./SigninBouyges"
import Home from "./Home"
import Profile from "./Profile"
import StProjects from "./st/StProjects"
import EcpProjects from "./ecp/EcpProjects"
import Lexicons from "./Lexicons"
import NeurowideDashboard from "./NeurowideDashboard/NeurowideDashboard"
import ProjectDashboard from "./NeurowideDashboard/ProjectDashboard"
import TeamDashboard from "./NeurowideDashboard/TeamDashboard"
import TeamManagement from "./TeamManagement"
import StWorkflow from "./st/StWorkflow"
import EcpWorkflow from "./ecp/EcpWorkflow"
import Help from "./Help"

export default function AllRoutes() {
    return (
        <>
        <Layout>
            <Routes>
                <Route path={"/signin"} element={<Signin/>}/>
                <Route path={"/signin-bouygues"} element={<SigninBouyges/>}/>
                <Route index element={<Home/>}/>
                <Route path={"/profile"} element={<Profile/>}/>
                <Route path={"/st/projects"} element={<StProjects/>}/>
                <Route path={"/st/workflow/:projectID"} element={<StWorkflow/>}/>
                <Route path={"/ecp/projects"} element={<EcpProjects/>}/>
                <Route path={"/ecp/workflow/:projectID"} element={<EcpWorkflow/>}/>
                <Route path={"/lexicons"} element={<Lexicons/>}/>
                <Route path={"/neurowide-dashboard/team/:teamID"} element={<TeamDashboard/>}/>
                <Route path={"/neurowide-dashboard/team/:teamID/:projectID"} element={<ProjectDashboard/>}/>
                <Route path={"/neurowide-dashboard"} element={<NeurowideDashboard/>}/>
                <Route path={"/team-management"} element={<TeamManagement/>}/>
                <Route path={"/help"} element={<Help/>}/>
            </Routes>
        </Layout>
        </>
    )
}